'use strict';
const sortedSubIdeas = require('@mindmup/mapjs-core/src/content/sorted-sub-ideas');
module.exports = function hierarchicalLabelGenerator(aggregate) {
	const isGroup = function (idea) {
			return idea && idea.attr && idea.attr.group;
		},
		join = function (parentLabel, ideaLabel) {
			if (!parentLabel) {
				return String(ideaLabel);
			}
			return `${parentLabel}.${ideaLabel}`;
		},
		traverse = function (contentIdea, labels, parentLabel) {
			sortedSubIdeas(contentIdea).forEach(function (subIdea, index) {
				const myLabel = join(parentLabel, index + 1);
				if (!isGroup(subIdea)) {
					labels[subIdea.id] =  myLabel;
				}
				traverse(subIdea, labels, myLabel);
			});

			return labels;
		};
	return traverse(aggregate, {});
};
